<article class="mx-auto max-w-5xl px-4 py-12 sm:px-6 lg:px-8 lg:py-16">
  <h1 class="font-display text-5xl font-semibold text-ink italic sm:text-6xl">Help</h1>

  <form class="mt-8 flex max-w-xl gap-2" (submit)="onSearchSubmit($event)">
    <label class="sr-only" for="help-search">Search help</label>
    <input
      id="help-search"
      type="search"
      name="q"
      [ngModel]="query()"
      (ngModelChange)="query.set($event)"
      placeholder="Search"
      autocomplete="off"
      class="min-w-0 flex-1 rounded-md border border-line bg-cream px-4 py-2.5 text-base text-ink placeholder:text-ink/40 focus:border-tan focus:outline-none focus:ring-1 focus:ring-tan"
    />
    <button
      type="submit"
      class="cursor-pointer shrink-0 rounded-md border border-ink bg-cream px-5 py-2.5 text-sm font-medium text-ink transition hover:bg-creamdark"
    >
      Search
    </button>
  </form>

  @if (categories().length === 0) {
    <p class="mt-16 text-base text-ink/70">
      No results for “{{ query() }}”. Try a different search.
    </p>
  } @else {
    <div class="mt-14 grid gap-x-16 gap-y-12 sm:grid-cols-2">
      @for (category of categories(); track category.id) {
        <section>
          <h2 class="font-display text-2xl font-semibold text-ink">{{ category.title }}</h2>
          <ul class="mt-4 divide-y divide-line border-t border-line">
            @for (item of category.items; track item.id) {
              <li>
                <button
                  type="button"
                  class="cursor-pointer flex w-full items-start justify-between gap-4 py-3.5 text-left text-base text-ink/80 transition hover:text-ink"
                  [attr.aria-expanded]="openId() === item.id"
                  (click)="toggle(item.id)"
                >
                  <span>{{ item.question }}</span>
                  <svg
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="1.5"
                    class="mt-1 h-4 w-4 shrink-0 text-ink/40 transition"
                    [class.rotate-180]="openId() === item.id"
                    aria-hidden="true"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="m19.5 8.25-7.5 7.5-7.5-7.5"
                    />
                  </svg>
                </button>
                @if (openId() === item.id) {
                  <p class="pb-4 text-sm leading-relaxed text-ink/70">{{ item.answer }}</p>
                }
              </li>
            }
          </ul>
        </section>
      }
    </div>
  }

  <p class="mt-16 border-t border-line pt-8 text-sm text-ink/60">
    Still stuck?
    <a routerLink="/contact" class="text-forest underline underline-offset-2 hover:text-forestdark"
      >Contact us</a
    >, or read our
    <a routerLink="/terms" class="text-forest underline underline-offset-2 hover:text-forestdark"
      >Terms of Use</a
    >
    and
    <a routerLink="/privacy" class="text-forest underline underline-offset-2 hover:text-forestdark"
      >Privacy Policy</a
    >.
  </p>
</article>
